export interface Contract {
  label: string
  ticker: string
  last: number
  change: number
  prevClose: number
  high: number
  low: number
  sparkline: number[]
  sparklineDateChanges: Record<string, any>
}

export interface FuturesDatum {
  ticker: string
  label: string
  contracts: Contract[]
}

export interface FuturesTile {
  change: number
  high: number
  label: string
  last: number
  low: number
  prevClose: number
  sparkline: number[]
  sparklineDateChanges: Record<string, any>
  ticker: string
}

export interface FuturesRow {
  ticker: string
  label: string
  group: string
  perf: number
}

export enum PageType {
  Quotes = 'quotes',
  Performance = 'performance',
  Charts = 'charts',
  Maps = 'maps',
}

export enum FuturesTimeframe {
  None = 'NO',
  Minute5 = 'i5',
  Hourly = 'h',
  Daily = 'd',
  Weekly = 'w',
  Monthly = 'm',
}

export enum LayoutType {
  Old = 'old',
  NewHorizontal = 'new',
  NewGroups = 'new_groups',
}

export enum LabelStyle {
  None = 'none',
  Plain = 'plain',
  PlainColor = 'plain_color',
  Side = 'side',
  SideColor = 'side_color',
  Line = 'line',
  LineWithEnding = 'lineWithEnding',
}

export enum TileStyle {
  Map = 'map',
  MapCondensed = 'mapCondensed',
  BorderTile = 'borderTile',
}
